import { createSlice } from '@reduxjs/toolkit';
import { startLoadingEvents } from './timelineSlice';

export const insightsSlices = createSlice({
  name: 'insights',
  initialState: {
    message: null,
    insights: [],
    activeInsights: null,
    lastUpdatedInsight: null,
    lastAction: null,
    isLoading: true,
  },
  reducers: {
    startLoadingInsights: (state /* action */) => {
      state.isLoading = true;
    },
    setAllInsights: (state, { payload }) => {
      state.isLoading = false;
      state.message = payload.message;
      state.insights = payload.insights;
      state.activeInsights = state.insights?.filter(
        (f) => f.action_status === null,
      ).length;
    },
    setLastUpdatedInsight: (state, { payload }) => {
      state.lastUpdatedInsight = payload.updatedInsight;
      state.lastAction = payload.actionId;
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoadingInsights, setAllInsights, setLastUpdatedInsight } =
  insightsSlices.actions;
